<template>

  <div id="HealthcareHours" class="HealthcareHours">

     <div class="">

        <!-- Healthcare Header -->
        <v-app-bar class="grey lighten-3 hidden-md-and-up" fixed elevate-on-scroll>
          <v-layout justify-center align-center>
            <v-icon large color="blue darken-3">mdi-hospital-box</v-icon>
            <span class="title blue--text text--darken-3 ml-1"> My Healthcare Experience</span>
          </v-layout>
        </v-app-bar>

        <!-- Total Healthcare Hours -->
        <v-container px-5 pb-0 pt-0 class="wrap">
          <v-card class="mt-2  elevation-0" flat tile>
            <v-container pb-1 pt-0 >
              <v-layout row align-center justify-center>
                <v-layout column align-center>
                  
                    <span class="percentageValue display-3 blue__text__color font-weight-medium">{{Math.round(totalHealthcareExperienceHours)}}</span>
                  
                  <p class="mt-2  grey--text">Total Healthcare Hours</p>
                </v-layout>
              </v-layout>
            </v-container>
          </v-card>
        </v-container>

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow hide-slider class="mt-5 weeeeee">
        <v-tab active-class="primary white--text" style="marginLeft:0px;">
          Healthcare Experience
        </v-tab>
        <v-tab active-class="primary white--text">
          Certifications
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- Healthcare Experience Tab -->
        <v-tab-item>
          <v-container mt-4 px-0 pt-0 pb-0 >
            <v-card flat outlined>
              <v-toolbar color="grey darken-3" dark flat>
                <v-toolbar-title>My Experiences</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn  v-if="!checkUserLoggedIn || !checkUserIsSubscribed" class="mr-1 elevation-0 "  dark color="grey lighten-1">Add Experience</v-btn>
                <v-btn v-else @click="addInstituition"  class="mr-1 pa-2 elevation-6"  dark  color="#D49129">Add Experience</v-btn>
              </v-toolbar>

              <v-card-text class="px-1 pb-0">

                <!-- Login or Signup Card -->
                <v-card v-if="!checkUserLoggedIn" class="elevation-0">
                  <v-card-text class="text-center black--text">
                    You need an active subscription to log healthcare/patient care experience
                  </v-card-text>
                  <v-card-actions>
                    <v-layout justify-center>
                      <v-btn to="/LoginSignupPage" style="width:40%"  class="elevation-0 mr-4" color="green" dark @click="showCreateSubscriptionDialog = false">
                        Login
                      </v-btn>
                      <v-btn to="/signup" style="width:40%"   class="elevation-0" color="primary" @click="showCreateSubscriptionDialog = false">
                        Signup
                      </v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>

                <!-- Active Subscription Card -->
                <v-card v-else-if="!checkUserIsSubscribed" class="elevation-0">
                  <v-card-text class="text-center black--text">
                    You need an active subscription to log healthcare experience
                  </v-card-text>
                  <v-card-actions>
                    <v-layout justify-center>
                      <v-btn to="/myaccount" block class="elevation-0" color="primary" >
                        My Account
                      </v-btn>
                    </v-layout>
                    <!-- <Prelogin /> -->
                  </v-card-actions>
                </v-card>

                <!-- User Healthcare Experience Info -->
                <div v-else-if="checkUserLoggedIn && checkUserIsSubscribed">
                  <v-card class="mb-2 pb-2 white" flat tile>
                    <!-- Direct Paid Patient Hours -->
                    <v-card v-if="directPaidPatientInfo.length > 0" class="mb-3 mt-3 grey lighten-4" style="borderRadius:5px" outlined>
                      <v-layout pt-2 px-2 justify-space-between mr-2>
                        <p class="subtitle-1 text--primary ml-2 mb-0">Direct Paid Patient Experience</p>
                        <span class="subtitle-1 blue__text__color">{{totalDirectPaidHours}} hrs</span>
                      </v-layout>
                      <DirectPaidHours v-for="directPaidPatient in directPaidPatientInfo" :key="directPaidPatient.id" :directPaidPatient="directPaidPatient " />
                    </v-card>

                    <!-- Direct Patient Hours -->
                    <v-card v-if="directPatientInfo.length > 0" class="mb-3 mt-5 grey lighten-4" style="borderRadius:5px" outlined>
                      <v-layout pt-2 px-2 justify-space-between mr-2>
                        <p class="subtitle-1 text--primary ml-2 mb-0">Direct Patient Experience</p>
                        <span class="subtitle-1 blue__text__color">{{totalDirectHours}} hrs</span>
                      </v-layout>
                      <DirectHours v-for="directHours in directPatientInfo" :key="directHours.id" :directHours="directHours "/>
                    </v-card>

                    <!-- Indirect Patient Hours -->
                    <v-card v-if="indirectPatientInfo.length > 0" class="mb-3 mt-5 grey lighten-4" style="borderRadius:5px"  outlined >
                      <v-layout  pt-2 px-2 justify-space-between mr-2>
                        <p class="subtitle-1 text--primary ml-2 mb-0">Indirect Patient Experience</p>
                        <span class="subtitle-1 blue__text__color">{{totalIndirectHours}} hrs</span>
                      </v-layout>

                      <IndirectHours v-for="indirectHours in indirectPatientInfo" :key="indirectHours.id" :indirectHours="indirectHours "/>
                    </v-card>

                    <!-- Volunteer Info -->
                    <v-card v-if="volunteerPatientInfo.length > 0" class="mb-3 mt-5 grey lighten-4" style="borderRadius:5px"  outlined >
                      <v-layout pt-2 px-2 justify-space-between mr-2>
                        <p class="subtitle-1 text--primary ml-2 mb-0">Volunteer Experience</p>
                        <span class="subtitle-1 blue__text__color">{{totalVolunteerHours}} hrs</span>
                      </v-layout>
                      <VolunteerHours v-for="volunteerHours in volunteerPatientInfo" :key="volunteerHours.id" :volunteerHours="volunteerHours "/>
                    </v-card>

                    <!-- Community Service Info -->
                    <v-card v-if="communityServiceInfo.length > 0" class="mb-3 mt-5 grey lighten-4" style="borderRadius:5px" outlined>
                      <v-layout  pt-2 px-2 justify-space-between mr-2>
                        <p class="subtitle-1 text--primary ml-2 mb-0">Community Service</p>
                        <span class="subtitle-1 blue__text__color">{{totalCommunityServiceHours}} hrs</span>
                      </v-layout>

                      <CommunityServiceHours v-for="communityServiceHours in communityServiceInfo" :key="communityServiceHours.id" :communityServiceHours="communityServiceHours "/>
                    </v-card>

                    <!-- No Experience Added -->
                    <v-container v-if=" directPaidPatientInfo .length === 0 && directPatientInfo .length === 0 && indirectPatientInfo.length === 0 && communityServiceInfo.length === 0 && volunteerPatientInfo.length === 0 && (user !== null && user !== undefined)" mt-3 pt-2>
                      <p class="ml-2 text-center body-1 mt-0 pt-1 grey--text text--darken-4 font-weight-light">
                        No healthcare experience saved. Add your experience to start logging your healthcare/patient care hours.
                      </p>
                    </v-container>
                  </v-card>
                </div>
              </v-card-text>

            </v-card>
          </v-container>
        </v-tab-item>

        <!-- Certifications Tab -->
        <v-tab-item>
          <v-container  mt-4 px-0 pt-0 >
            <v-card flat outlined>

              <v-toolbar color="grey darken-3" dark flat>
                <v-toolbar-title>My Certifications</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn  v-if="!checkUserLoggedIn || !checkUserIsSubscribed" class="mr-1 elevation-0 "  dark color="grey lighten-1">Add</v-btn>
                <v-btn v-else @click="addCertification"  class="mr-1 pa-2 elevation-6"  dark  color="#D49129">Add</v-btn>
              </v-toolbar>

              <v-card-text class="px-1">
                <!-- Login or Signup Card -->
                <v-card v-if="!checkUserLoggedIn" class="elevation-0">
                  <v-card-text class="text-center black--text">You need an active subscription to log certifications</v-card-text>
                    <v-card-actions>
                      <v-layout justify-center>
                        <v-btn to="/LoginSignupPage" style="width:40%"  class="elevation-0 mr-4" color="green" dark @click="showCreateSubscriptionDialog = false">
                              Login
                            </v-btn>
                            <v-btn to="/signup" style="width:40%"   class="elevation-0" color="primary" @click="showCreateSubscriptionDialog = false">
                              Signup
                            </v-btn>
                      </v-layout>
                    </v-card-actions>
                </v-card>

                <!-- Active Subscription Card -->
                <v-card v-else-if="!checkUserIsSubscribed" class="elevation-0">
                  <v-card-text class="text-center black--text">
                    You need an active subscription to log certifications
                  </v-card-text>
                  <v-card-actions>
                    <v-layout justify-center>
                      <v-btn to="/myaccount" block class="elevation-0" color="primary" >
                        My Account
                      </v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>

                <!-- User Certification Info -->
                <v-card  v-else-if="checkUserLoggedIn && checkUserIsSubscribed" class="card pb-0 white" flat>
                  <Certification v-if="certificationsInfo.length > 0" v-for="certification in certificationsInfo" :key="certification .id" :certification ="certification"/>
                  <v-container v-if="certificationsInfo.length === 0" mt-3 pt-2>
                    <p class="ml-2 text-center body-1 mt-0 pt-1 grey--text text--darken-4 font-weight-light">
                      No certifications saved
                    </p>
                  </v-container>
                </v-card>
              </v-card-text>
            </v-card>
          </v-container>
        </v-tab-item>
      </v-tabs-items>

      <div class="video-container" > <iframe width="560" height="315" src="https://www.youtube.com/embed/dz-lTj_zAdo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>

      <!-- Back Button -->
      <v-btn class="mr-4 ml-2 fixed elevation-0 hidden-sm-and-up" color="red" fab rounded small @click="back">
        <v-icon medium color="white">
          mdi-arrow-left
          </v-icon>
      </v-btn>
      </div>

  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  export default {
    mixins: [userMixins],
    data() {
      return {
        show: false,
        tab: null,
      }
    },
    mounted() {
      document.querySelector('.v-slide-group__prev--disabled').style.flexBasis = 0
      document.querySelector('.v-slide-group__prev--disabled').style.minWidth = 0
    },
    methods: {
      back() {
        this.$router.push('/dashboard')
      },
      addInstituition () {
        this.$router.push('/dashboard/healthcarehours/addexperience')
      },
      addCertification () {
        this.$router.push('/dashboard/healthcarehours/addcertification')
      }
    },
    computed: {
      user() {
        return this.$store.getters.user;
      },
      totalHealthcareExperienceHours() {
        return this.$store.getters.totalHealthcareExperienceHours
      },
      directPaidPatientInfo () {
        return this.$store.getters.directPaidPatientInfo;
      },
      totalDirectPaidHours () {
        return this.$store.getters.totalDirectPaidHours;
      },
      directPatientInfo () {
        return this.$store.getters.directPatientInfo;
      },
      totalDirectHours () {
        return this.$store.getters.totalDirectHours;
      },
      indirectPatientInfo () {
        return this.$store.getters.indirectPatientInfo;
      },
      totalIndirectHours () {
        return this.$store.getters.totalIndirectHours;
      },
      volunteerPatientInfo () {
        return this.$store.getters.volunteerPatientInfo;
      },
      totalVolunteerHours () {
        return this.$store.getters.totalVolunteerHours;
      },
      communityServiceInfo() {
        return this.$store.getters.communityServiceInfo;
      },
      totalCommunityServiceHours () {
        return this.$store.getters.totalCommunityServiceHours;
      },
      certificationsInfo () {
        return this.$store.getters.certificationsInfo;
      }
    }
  }
</script>

<style scoped>

.video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 35px;
    height: 0;
    overflow: hidden;

}


.video-container iframe {
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 80%;
    box-shadow: 0 10px 20px -10px rgba(0,0,0,.19) !important;
    border-radius: 5px;
    margin-top:30px;
}

a {
  text-decoration: none;
}

.card {
  border-radius: 5px;
  border: 1px solid rgb(231, 231, 231);
}

#buttonShadow {
  box-shadow: 0 10px 20px -5px rgba(0,0,0,.19);
}

.fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom:65px;
}

img {
  width:50px;
  height:50px;
}

.linkLogo {
  width:33px;
  height:33px;
  margin-left:10px;
  margin-right: 10px;
  border-radius:5px;
}

.tweetLogo {
  width:37px;
  height:37px;
  margin-left:10px;
  margin-right: 10px;
  border-radius:10px;
}

.blueHeading {
  color:#2196F3;
}

@media (max-width: 900px) {

  .wrap {
    margin-top: 8vh !important;
  }
  
}

.blue__text__color {
  color:#005880;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/HealthcareHours.vue